import { SET_CATERINGPORDER } from '../actions';

const cateringpast = (state = [], action) => {
  switch (action.type) {
    case SET_CATERINGPORDER:
      return [...action.value];
    default: return state;
  }
}

export default cateringpast;
